import PropTypes from 'prop-types';
// @mui
import { Stack, InputAdornment, TextField, MenuItem, Button } from '@mui/material';
// components
import Iconify from '../../components/iconify';

// ----------------------------------------------------------------------

TableToolbar.propTypes = {
  filterText: PropTypes.string,
  onFilterText: PropTypes.func,
  onResetFilter: PropTypes.func,
  roleOptions: PropTypes.array,
  fraudOptions: PropTypes.array,
  filterRole: PropTypes.string,
  filterFraud: PropTypes.string,
  onFilterRole: PropTypes.func,
  onFilterFraud: PropTypes.func,
  selectOptions: PropTypes.array,
  filterSelectValue: PropTypes.string,
  onFilterSelect: PropTypes.func,
  selectLabel: PropTypes.string,
};

export default function TableToolbar({
  filterText,
  onFilterText,
  onResetFilter,

  roleScope = '',

  roleOptions = [],
  fraudOptions = [],
  filterRole = '',
  filterFraud = '',
  onFilterRole,
  onFilterFraud,

  selectOptions = [],
  filterSelectValue = '',
  onFilterSelect,
  selectLabel = '',
}) {
  const isFiltered = !!filterText || !!filterSelectValue;

  return (
    <Stack
      spacing={2}
      alignItems="center"
      direction={{ xs: 'column', sm: 'row' }}
      sx={{ px: 2.5, py: 3 }}
    >
      {/* 🔹 Filter Role */}
      {roleOptions.length > 0 && (
        <TextField
          select
          label="Role"
          value={filterRole}
          onChange={onFilterRole}
          sx={{ width: 100 }}
        >
          <MenuItem value={roleScope}>All</MenuItem>
          {roleOptions.map((option) => (
            <MenuItem key={option.id} value={option.id}>
              {option.name}
            </MenuItem>
          ))}
        </TextField>
      )}

      {/* 🔹 Filter Fraud */}
      {fraudOptions.length > 0 && (
        <TextField
          select
          label="Fraud"
          value={filterFraud}
          onChange={onFilterFraud}
          sx={{ width: 120 }}
        >
          <MenuItem value="">All</MenuItem>
          {fraudOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      )}

      {selectOptions.length > 0 && (
        <TextField
          select
          label={selectLabel}
          value={filterSelectValue}
          onChange={onFilterSelect}
          sx={{ maxWidth: 240 }}
        >
          {selectOptions.map((option) => (
            <MenuItem key={option.id || option} value={option.value || option}>
              {option.label || option.name || option}
            </MenuItem>
          ))}
        </TextField>
      )}

      <TextField
        fullWidth
        value={filterText}
        onChange={onFilterText}
        placeholder="Search..."
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled' }} />
            </InputAdornment>
          ),
        }}
      />

      {isFiltered && (
        <Button
          color="error"
          onClick={onResetFilter}
          startIcon={<Iconify icon="eva:trash-2-outline" />}
        >
          Clear
        </Button>
      )}
    </Stack>
  );
}

